<template>
  <v-list-item test-tag="tag-139" ref="item" :dense="$vuetify.breakpoint.xs" link three-line :to="''+orderId" active-class="active">
    <!-- <v-list-item-avatar><v-icon large>mdi-food</v-icon></v-list-item-avatar> -->
    <v-list-item-avatar >
      <v-badge
        color="red"
        overlap
        :value="showTransactionWarning"
      >
        <v-icon large :color="syncState[order.sync_state].color">
          {{ displayedIcon }}
        </v-icon>
      </v-badge>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>#{{orderId}}</v-list-item-title>
      <v-list-item-subtitle>{{order.guest.name}}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="order.order_type == 'DELIVERY'">{{order.address.value}}</v-list-item-subtitle>
      <v-list-item-subtitle><PhoneFormatter v-model="order.phone.number"></PhoneFormatter></v-list-item-subtitle>
    </v-list-item-content>
    <!-- <v-icon v-if="$vuetify.breakpoint.mdAndUp" large>mdi-cash-off</v-icon> -->
  </v-list-item>
</template>

<script>
import PhoneFormatter from '@/components/common/PhoneFormatter.vue'
import { SyncStatus } from '@/helpers/status_helper.js'

export default {
  props:{
    orderId: {
      type: Number
    },
    order:{
      type: Object
    }
  },
  data: ()=>({
    syncState: SyncStatus
  }),
  computed:{
    routeOrderId(){
      return this.$route.params.orderId
    },
    showTransactionWarning(){
      return (
        ['EXPIRED', 'CANCELED'].includes(this.order.transaction_status) &&
        this.order.status === 'WAIT_PAY'
      )
    },
    displayedIcon(){
      if (this.order.status === 'WAIT_PAY') {
        return 'mdi-cash-off'
      }
      let sync_state_icon = this.syncState[this.order.sync_state].icon
      return sync_state_icon ? sync_state_icon : this.order.order_type == 'DELIVERY' ? 'mdi-truck-fast' : 'mdi-food' 
    }
  },
  watch:{
    $route() {
      this.scrollIfFocused()
    }
  },
  methods:{
    scrollIfFocused(){
      if (this.routeOrderId) {
        if (this.routeOrderId == this.orderId) {
          this.$refs.item.$el.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
      }
    }
  },
  mounted(){
    this.scrollIfFocused()
  },
  components:{
    PhoneFormatter
  }
}
</script>

<style scoped>

.v-list-item__avatar {
  overflow: visible;
}

.v-list-item > .v-icon {
  display: none;
} 

.active > .v-icon {
  display: block;
  position: absolute;
  right: 10px;
}
/* .active::after, .active::before {
  content: " ";
  position: absolute;
  right: 15px;
  left: auto;
  top: 50%;
  height: 3px;
  width: 15px;
  background-color: var(--v-secondary-base) !important;
  transition: none !important;
  opacity: 1 !important;
  min-height: auto !important;
}

.active::after {
  transform: rotate(45deg) translateY(-6px);
}

.active::before {
  transform: rotate(-45deg) translateY(6px);
} */
</style>